import apiHub from "./apiHub";

export async function addInquiry(inquiryData) {
  return await apiHub.post("/inquiry", inquiryData);
}
